import { graphql, useStaticQuery } from 'gatsby';

import { BlogPostI } from 'interfaces/content-stack/blogPost';

interface FetchArticlesProps {
  pullFeaturedArticle?: boolean;
  featuredArticleId?: string;
  limit?: number;
}

export const useFetchArticles = ({ pullFeaturedArticle, featuredArticleId }: FetchArticlesProps) => {
  const articlesQuery = useStaticQuery(graphql`
    query {
      recentArticles: allContentstackArticles(limit: 5, sort: { post_date: DESC }) {
        nodes {
          id
          title
          url
          featuredArticle: featured_article
          bodyContent: body_content
          metadata {
            excerpt
            thumbnailImage: thumbnail_image {
              url
            }
            imageAltText: thumbnail_alt_text
            imageCaption: thumbnail_image_caption
          }
          postDate: post_date
          breadcrumb {
            title
            url
          }
        }
      }
      featuredArticles: allContentstackArticles(
        limit: 1
        filter: { featured_article: { eq: true } }
        sort: { post_date: DESC }
      ) {
        nodes {
          id
          title
          url
          featuredArticle: featured_article
          bodyContent: body_content
          metadata {
            excerpt
            thumbnailImage: thumbnail_image {
              url
            }
            imageAltText: thumbnail_alt_text
            imageCaption: thumbnail_image_caption
          }
          postDate: post_date
          breadcrumb {
            title
            url
          }
        }
      }
    }
  `);

  const recentArticles: BlogPostI[] = articlesQuery.recentArticles.nodes;
  const featuredArticle: BlogPostI = pullFeaturedArticle ? articlesQuery.featuredArticles.nodes[0] : recentArticles[0];
  const filteredRecentArticles: BlogPostI[] = recentArticles.filter(
    (article) => article.id !== (featuredArticleId ?? featuredArticle.id)
  );

  return { featuredArticle, recentArticles, filteredRecentArticles };
};
